var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	},
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
};

site.frontpage = {
	frontCarousel: false,
	init: function () {
		site.frontpage.hasScrolled();
		site.frontpage.initFrontpageCarousel();

		$(window).resize(function () {
			site.frontpage.initFrontpageCarousel();
		});

		site.owl.init('#logos > ul', {
			loop: true,
			nav: true,
			margin: 10,
			autoplay: false,
			autoplayTimeout: 6000,
			responsive: {
				0: {items: 1},
				500: {items: 2},
				992: {items: 4},
				1400: {items: 6},
			},
			navText: [
				'<i class=\'fa fa-arrow-left\'></i>',
				'<i class=\'fa fa-arrow-right\'></i>',
			],
		});
	},

	initFrontpageCarousel: function () {
		var $currentWidth = $(window).width();
		if ($currentWidth < 768) {
			if (!site.frontpage.frontCarousel) {
				site.owl.init('#ad_wrapper ul', {
					items: 1,
					nav: true,
					navText: ['', ''],
				});
				site.frontCarousel = true;
			}
		}
		else {
			if (site.frontpage.frontCarousel) {
				site.frontpage.frontCarousel.owlCarousel('destroy').removeClass('owl-carousel owl-loaded');
				site.frontpage.frontCarousel = false;
			}
		}
	},

	hasScrolled: function () {
		window.addEventListener('scroll', function (e) {
			var distanceY = window.pageYOffset || document.documentElement.scrollTop,
				$bannerHeight = $('.banner__image').innerHeight();
			if (distanceY > $bannerHeight) {
				$('body').addClass('hasScrolled');
			}
			else {
				$('body').removeClass('hasScrolled');
			}
		});
	},
};

site.newsHeadlines = {
	init: function () {
		if (!$('.box_newsheadlines').length) {
			return;
		}
		site.owl.init('.box_newsheadlines .menu', {
			loop: false,
			dots: false,
			margin: 30,
			items: 4,
			nav: true,
			navText: ['', ''],
			responsive: {
				0: {
					items: 1,
				},
				768: {
					items: 2,
				},
				992: {
					items: 4,
				},
			},
		});
	},
};

site.iconList = {
	init: function () {
		const iconLists = document.querySelectorAll('ul.iconList');
		if (iconLists.length === 0) {
			return;
		}
		iconLists.forEach(iconList => {
			const listItems = iconList.querySelectorAll('li');
			if (listItems.length > 4) {
				iconList.classList.add('hasMore');
				const toggleButton = document.createElement('button');
				toggleButton.classList.add('btn');
				toggleButton.classList.add('btn-primary');
				toggleButton.innerText = 'Sjá fleiri skjöl';
				let existingListItem = listItems.item(4);
				existingListItem.parentNode.insertBefore(toggleButton, existingListItem);

				toggleButton.addEventListener('click', () => {
					iconList.classList.remove('hasMore');
					toggleButton.remove();
				});
			}
		});
	},
};

site.employees = {
	init: function () {
		$(document).ready(function () {
			$('.employee__single .wrapper').hover(function () {
				var maxHeight = $(this).find('.extraInfo').css('max-height');
				$(this).find('.extraInfo').stop().height(maxHeight);
			}, function () {
				if (!$(this).hasClass('clicked')) {
					$(this).find('.extraInfo').stop().height(0);
				}
			});

			$('.employee__single .wrapper').click(function () {
				var maxHeight = $(this).find('.extraInfo').css('max-height');
				$(this).toggleClass('clicked');
				if ($(this).hasClass('clicked')) {
					$(this).find('.extraInfo').stop().height(maxHeight);
				}
				else {
					$(this).find('.extraInfo').stop().height(0);
				}
			});
		});
	},
};


// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();
	site.megamenu.init();
	site.iconList.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.employees')) {
		site.employees.init();
	}
	site.newsHeadlines.init();

	MoyaComponents.register('site.fancybox', [
		'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css',
		'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js',
	], () => {
		Fancybox.bind('[data-fancybox]', {
			groupAll: true,
			Thumbs: {
				autoStart: false,
			},
		});
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
